import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { SectionBlock, Title } from "../../talent.styled";
import { ShowMore, Skill, SkillsList } from "../candidate-skills/candidate-skills.styled";
import { city } from "../../../../models/candidate-detail.model";
import { FaPlusCircle } from "react-icons/fa";

interface MoveLocationsProps {
  moveLocations: city[];
}

const MoveLocations: React.FC<MoveLocationsProps> = ({ moveLocations }) => {
  const { t } = useTranslation("private-home-page");
  const [showAll, setShowAll] = React.useState<boolean>(false);

  const itens = useMemo(() => 
    showAll ? moveLocations : moveLocations?.slice(0, 3), 
  [moveLocations, showAll]);

  return  (
    <SectionBlock>
      <Title>{t("talent.moveLocation")}</Title>
      <SkillsList>
        {itens?.map((mv, index) => (
          <Skill key={`${index}_${mv.id}`}>
            {mv.name}/{mv.state}
          </Skill>
        ))}
        {!showAll && <Skill className="show-more">
          <ShowMore onClick={() => setShowAll(!showAll)}>
            {t("talent.showMore")}
            <FaPlusCircle />
          </ShowMore>
        </Skill>}
      </SkillsList>
    </SectionBlock>
  );
};

export default MoveLocations;
